const MQ = window.matchMedia('(min-width: 768px)');

const timerData = new WeakMap();
const contentMap = new WeakMap();
const panelsMap = new WeakMap();

const getActiveButton = (tabBlock) =>
	tabBlock.querySelector('.block-tab-standard-tab > .wp-block-button.active');

const getTimerDuration = (tabBlock) =>
	parseFloat(
		(
			getComputedStyle(tabBlock).getPropertyValue(
				'--tab-timer-duration'
			) || '6s'
		).trim()
	) * 1000;

const stopTimer = (tabBlock) => {
	const data = timerData.get(tabBlock);
	if (data?.timer) clearTimeout(data.timer);
};

const startTimer = (tabBlock) => {
	stopTimer(tabBlock);
	const d = getTimerDuration(tabBlock);
	const timer = setTimeout(() => advanceTab(tabBlock), d);
	timerData.set(tabBlock, { startTime: Date.now(), duration: d, timer });
};

const advanceTab = (tabBlock) => {
	const activeButton = getActiveButton(tabBlock);
	if (!activeButton) return;

	const tabs = tabBlock.querySelectorAll('.block-tab-standard-tab');
	const currentIndex = parseInt(
		activeButton
			.closest('.block-tab-standard-tab')
			.getAttribute('data-index') ?? '0'
	);
	const nextIndex = (currentIndex + 1) % tabs.length;
	const nextButton = tabBlock.querySelector(
		`.block-tab-standard-tab[data-index="${nextIndex}"] > .wp-block-button`
	);

	if (nextButton) switchTab(tabBlock, nextButton);
};

const updatePagination = (tabBlock) => {
	const activeButton = getActiveButton(tabBlock);
	if (!activeButton) return;

	const tabs = tabBlock.querySelectorAll('.block-tab-standard-tab');
	const currentIndex = parseInt(
		activeButton
			.closest('.block-tab-standard-tab')
			.getAttribute('data-index') ?? '0'
	);

	const prevButton = tabBlock.querySelector(
		'.block-tab-standard__mobile-pagination .button-prev'
	);
	const nextButton = tabBlock.querySelector(
		'.block-tab-standard__mobile-pagination .button-next'
	);

	if (prevButton) prevButton.disabled = currentIndex === 0;
	if (nextButton) nextButton.disabled = currentIndex === tabs.length - 1;
};

const switchTab = (tabBlock, newButton, userInitiated = false) => {
	const activeButton = getActiveButton(tabBlock);
	if (activeButton === newButton) return;

	stopTimer(tabBlock);

	// contentMap only has entries on desktop — optional chaining makes these
	// no-ops on mobile, where CSS handles content visibility instead.
	const activeContent = activeButton ? contentMap.get(activeButton) : null;
	const newContent = contentMap.get(newButton);

	const selectElement = tabBlock.querySelector(
		'.block-tab-standard__mobile-select'
	);
	const tab = newButton.closest('.block-tab-standard-tab');
	if (tab?.hasAttribute('data-index') && selectElement) {
		selectElement.value = tab.getAttribute('data-index');
	}

	activeButton?.classList.remove('active');
	activeContent?.classList.remove('is-active');

	newButton.classList.add('active');
	newContent?.classList.add('is-active');

	if (!userInitiated && panelsMap.has(tabBlock)) {
		startTimer(tabBlock);
	}

	updatePagination(tabBlock);
};

const setupDesktop = (tabBlock) => {
	if (panelsMap.has(tabBlock)) return;

	const content = tabBlock.querySelector('.block-tab-standard__content');
	if (!content) return;

	const panels = document.createElement('div');
	panels.className = 'block-tab-standard__panels';
	content.appendChild(panels);
	panelsMap.set(tabBlock, panels);

	tabBlock.querySelectorAll('.block-tab-standard-tab').forEach((tab) => {
		const tabButton = tab.querySelector(':scope > .wp-block-button');
		const contentSection = tab.querySelector(
			':scope > .block-content-section'
		);
		if (!tabButton || !contentSection) return;

		panels.appendChild(contentSection);
		contentMap.set(tabButton, contentSection);
	});

	const activeButton = getActiveButton(tabBlock);
	if (activeButton) {
		contentMap.get(activeButton)?.classList.add('is-active');
	}

	tabBlock.classList.add('is-active');

	startTimer(tabBlock);
};

const teardownDesktop = (tabBlock) => {
	const panels = panelsMap.get(tabBlock);
	if (!panels) return;

	stopTimer(tabBlock);

	tabBlock.querySelectorAll('.block-tab-standard-tab').forEach((tab) => {
		const tabButton = tab.querySelector(':scope > .wp-block-button');
		if (!tabButton) return;

		const contentSection = contentMap.get(tabButton);
		if (contentSection) {
			contentSection.classList.remove('is-active');
			tab.appendChild(contentSection);
			contentMap.delete(tabButton);
		}
	});

	panels.remove();
	panelsMap.delete(tabBlock);
};

document.querySelectorAll('.block-tab-standard').forEach((tabBlock) => {
	const tabs = tabBlock.querySelectorAll('.block-tab-standard-tab');
	if (!tabs.length) return;

	const content = tabBlock.querySelector('.block-tab-standard__content');
	if (!content) return;

	const selectElement = tabBlock.querySelector(
		'.block-tab-standard__mobile-select'
	);

	tabs.forEach((tab, index) => {
		const tabButton = tab.querySelector(':scope > .wp-block-button');
		if (!tabButton) return;

		tab.setAttribute('data-index', index);
		tabButton.classList.add('initialized');

		if (selectElement) {
			const option = document.createElement('option');
			option.value = index;
			option.text = tabButton.textContent.trim();
			selectElement.appendChild(option);
		}

		tabButton
			.querySelector('.wp-block-button__link, button')
			?.addEventListener('click', (e) => {
				e.preventDefault();
				switchTab(tabBlock, tabButton, true);
				tabBlock.classList.remove('is-active');
			});
	});

	if (selectElement) {
		selectElement.addEventListener('change', (e) => {
			const newButton = tabBlock.querySelector(
				`.block-tab-standard-tab[data-index="${e.currentTarget.value}"] > .wp-block-button`
			);
			if (newButton) switchTab(tabBlock, newButton);
		});
		content.appendChild(selectElement);
	}

	tabBlock
		.querySelectorAll('.block-tab-standard__mobile-pagination button')
		.forEach((button) => {
			button.addEventListener('click', (e) => {
				const activeButton = getActiveButton(tabBlock);
				if (!activeButton) return;

				const isPrev =
					e.currentTarget.classList.contains('button-prev');
				const currentIndex = parseInt(
					activeButton
						.closest('.block-tab-standard-tab')
						.getAttribute('data-index') ?? '0'
				);
				const allTabs = tabBlock.querySelectorAll(
					'.block-tab-standard-tab'
				);
				const nextIndex = isPrev ? currentIndex - 1 : currentIndex + 1;
				if (nextIndex < 0 || nextIndex >= allTabs.length) return;

				const nextButton = tabBlock.querySelector(
					`.block-tab-standard-tab[data-index="${nextIndex}"] > .wp-block-button`
				);
				if (nextButton) switchTab(tabBlock, nextButton);
			});
		});

	const firstButton = tabBlock.querySelector(
		'.block-tab-standard-tab > .wp-block-button'
	);
	if (firstButton) {
		firstButton.classList.add('active');
		updatePagination(tabBlock);
	}

	if (MQ.matches) {
		setupDesktop(tabBlock);
	}

	MQ.addEventListener('change', (e) => {
		if (e.matches) {
			setupDesktop(tabBlock);
		} else {
			teardownDesktop(tabBlock);
		}
	});
});
